import { useLayoutEffect } from 'react';
import api from '../services/api';

type UseHandleBrandContextInSessionStorageProps = {
  brandId?: string;
  enabled?: boolean;
};

const useHandleBrandContextInSessionStorage = ({
  brandId,
  enabled = true,
}: UseHandleBrandContextInSessionStorageProps) => {
  useLayoutEffect(() => {
    const brandIdInSession = api.getBrandContextFromSession();
    if (!enabled || brandIdInSession) {
      return;
    }
    if (brandId) {
      api.setBrandContextInSession(brandId);
    }
    return () => {
      api.setBrandContextInSession(undefined);
    };
  }, [brandId, enabled]);
};

export default useHandleBrandContextInSessionStorage;
